import React from "react";
import {
  LeftOutlined,
  CalendarOutlined,
  HomeOutlined,
  UserOutlined,
  LaptopOutlined,
  ReloadOutlined
} from "@ant-design/icons";
import { Skeleton, Layout, message, theme, ConfigProvider, Image } from "antd";
import { getCurrentShopId } from "./pages/shop/get-current-shop";
import zhCN from 'antd/es/locale/zh_CN';
import "./App.css";
import "./styles/tailwind.css";  // 引入 Tailwind CSS
import { SafeStorage, detectWebView } from './utils/jsbridge';

message.config({
  top: 80,
});

const { Header, Content, Sider, Footer } = Layout;
const {isWebView} = detectWebView();

const ignorePath = [
  '/logout',
  '/login',
  '/regist',
  '/regist2',
  '/waiting',
  '/forget',
];
const App = (props) => {
  const [loading, setLoading] = React.useState(true);
  const [userAbility, setUserAbility] = React.useState();
  const [currentShopId, setCurrentShopId] = React.useState();

  React.useEffect(() => {
    const fetchCurrentShopId = async () => {
      const shopId = await getCurrentShopId();
      setCurrentShopId(shopId);
    };
    
    fetchCurrentShopId();
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const getUserAblity = async () => { 
    console.log('Fetching user ability from API');
    const response = await fetch(`/api/account/user-permission?shopId=${currentShopId}`);
    const result = await response.json();
    console.log('User ability API response:', result);

    if(result && result.success) {
      await SafeStorage.setItem('user-ability', JSON.stringify(result.data), true);
      console.log('User ability saved to sessionStorage');
      return result.data;
    }

    console.log('Failed to fetch user ability');
    return []
  };

  React.useEffect(() => {
    SafeStorage.getItem('user-ability', true).then(stored => {
      if(!stored) {
        getUserAblity().then((res) => {
          setUserAbility(res);
          setLoading(false);
        }).catch(() => {
          setLoading(false);
        }).finally(() => {
          setLoading(false);
        });
      } else {
        try {
          const parsed = JSON.parse(stored);
          setUserAbility(parsed);
        } catch (e) {
          console.error('Failed to parse stored user ability:', e);
        }
        setLoading(false);
      }
    });
  }, []);

  return (
    <ConfigProvider locale={zhCN} theme={{ 
      token: { 
        colorPrimary: "#00b96b", 
        // colorBorderSecondary: "#d9d9d9" 
      },
      components: {
        Form: {
          verticalLabelPadding: "0 0 0 0",
          itemMarginBottom: '10px',
        },
        Table: {
          headerBorderRadius: 5,
        },
        Card: {
          bodyPadding: '12px'
        },
        Menu: {
          itemBg: 'rgba(0, 0, 0, 0.04)'
        }
      }
    }}>
      <Layout className="app-layout">
        {/* <div id='refresh-msg' style={{ zIndex: 100, position: 'absolute', color: 'green', width: '100%', height: '20px', overflow: 'hidden', display: 'none', 'textAlign': 'center'}}>刷新?</div> */}
        {window.__baseInfo.noHeader !== true && <Header
          className={`app-header ${isWebView ? 'webview' : ''}`}
        >
          <div className="app-header-logo">
            <LeftOutlined 
              className="app-header-icon" 
              onClick={() => window.history.back()} 
            />

            <ReloadOutlined 
              className="app-header-icon" 
              onClick={() => window.location.reload()} 
            />
            
            <img 
              className="app-header-logo-img"
              src="https://img.yxdj.tech/yxdj-system/logo.png?x-oss-process=image/resize,w_60" 
              alt="Logo"
            />
            
            优选到家系统
          </div>
          <div className="app-header-user">
            {window.__baseInfo.username}
            <a className="app-header-logout" href="/logout">退出</a>
          </div>
        </Header>}
        <Layout style={{flexGrow: 1}}>
          <Content
            className={`app-content ${isWebView ? 'webview' : ''}`}
          >
            {/* 全局内容容器 - 限制最大宽度 */}
            <div className="app-content-wrapper">
              {loading ? <Skeleton rows={10} /> : props.children}
            </div>
          </Content>
        </Layout>
        {/* <Footer className="app-footer">
          &nbsp;
        </Footer> */}
      </Layout>
      {
      window.__baseInfo.noFooter !== true && !ignorePath.includes(window.location.pathname) && 
        <div className="app-tabbar-container">
          <nav className="app-tabbar-nav">
            <a href="/index" className="app-tabbar-item">
              <HomeOutlined className="app-tabbar-icon" />
              <div>首页</div>
            </a>
            {(window.__baseInfo.userId === '154955145316' || window.__baseInfo.userId === '565585262612') && (
              <a href="/sys" className="app-tabbar-item">
                <LaptopOutlined className="app-tabbar-icon" />
                <div>系统首页</div>
              </a>
            )}
            <a href="/schedule" className="app-tabbar-item">
              <CalendarOutlined className="app-tabbar-icon" />
              <div>日程</div>
            </a>
            <a href="/my" className="app-tabbar-item">
              <UserOutlined className="app-tabbar-icon" />
              <div>我的</div>
            </a>
          </nav>
        </div>
      }
    </ConfigProvider>
  );
};

export default App;
